import { Language } from "@/Common/Models/Domain/Language";
import { LANG_STORAGE_KEY, LOCALE_STORAGE_SERVICE } from "../Model/Constants";

import useUserStore from "@/Modules/User/Store";

import { LocalStorageService } from "@/Services/LocalStorageService";

import { normalizeLanguage } from "@/Utils/Language";

function GetCurrentLocaleActionHandler(): Language {
  const userStore = useUserStore();
  const userLanguage = normalizeLanguage(userStore.user?.language);

  if (userLanguage) return userLanguage;

  const localStorageService = new LocalStorageService(LOCALE_STORAGE_SERVICE);
  const localStorageLang: string = localStorageService.get(LANG_STORAGE_KEY);

  return normalizeLanguage(localStorageLang) ?? normalizeLanguage(navigator.language) ?? Language.ENGLISH;
}

export default GetCurrentLocaleActionHandler;
